<template>
  <div v-bind:class="`${customClases}`">
    <div v-bind:class="`${mobileVersion ? 'qrCodeScanContainer' : ''}`">
      <div class="label">{{ label }}</div>
      
      <div>
        <el-input 
          name="nro_serie"
          :placeholder="$t('GARANTIAS_numero_serie')"
          size="small"
          v-model="nsValue" 
          @blur="getDescripcion"
          v-bind:class="mobileVersion && readonly === false ? 'qrCodeScanInput' : ''"
          :readonly="scanEnabled === true || readonly"
          @input="upper"   
          @change="serieCargada"           
        />
        <div v-if="mobileVersion && readonly === false" class="qrCodeScanIcon">
          <img src='@/images/qr_code_scan.png' @click="onCodeScanIconTouch" />
        </div>
      </div>
    </div>

    <div v-if="nsDescription != '' && scanEnabled === false" v-bind:class="`descripcion ${validNs ? '' : 'invalido'}`">{{nsDescription}}</div>

    <div v-bind:class="`qrCodeReader ${scanEnabled ? 'enabled' : 'disabled'}`">
      <QRCodeScanner :readEnable="scanEnabled" :onScan="onCodeScanned" />
    </div>
  </div>
</template>

<script>
  import { isMobile } from '../Helpers/commonFunctions'
  import { getMensajeInternacionalizado } from '../MensajeInternacionalizado'
  import QRCodeScanner from '../QRCodeScanner'

  export default {
    name: 'NumeroSerieInput',
    components: { QRCodeScanner },
    props: {
      name: String,
      label: String,
      modelValue: String,
      onChange: Function,
      readonly: { propType: Boolean, default: false },
      customClases: String      
    },
    data() {
      return {
        nsValue: this.modelValue,
        nsDescription: '',
        esNs:'',
        lastNsSearched: '',
        validNs: false,
        scanEnabled: false
      }
    },
    computed: {
      mobileVersion() {
        return isMobile.any() !== null
      }
    },
    methods: {
      serieCargada(value) {
        this.$emit('cargaSerieCompleta', value);
      },
      onCodeScanIconTouch() {
        this.scanEnabled = !this.scanEnabled
      },
      onCodeScanned(code) {
        this.scanEnabled = false
        this.nsValue = code.substr(2, 12)
        this.$emit('update:modelValue', this.nsValue)
        this.getDescripcion()
      },
      upper(){
        this.nsValue = this.nsValue.toUpperCase()
        this.$emit('update:modelValue', this.nsValue)
      },
      getDescripcion() {
        
        // valido si se modificó el valor del campo para actualizar su descripción
        if(this.lastNsSearched === this.nsValue)
          return

        // guardo la últma descripción buscada para el campo
        this.lastNsSearched = this.nsValue

        // si no se ingresó un valor de campo, limpio la descripción
        if(!this.nsValue)
        {
          this.nsDescription = '';
          this.validNs=false;
          this.esNs ='N';
          this.ocultar();
          this.onChange({ name: this.name, value: this.nsValue, description: this.nsDescription, valid: this.validNs });
          return
        }
        
        // busco la descripción del campo
        this.$store.dispatch('solicitudes/getDescripcion', { identificadorElemento: this.nsValue })
        .then(result => {

          // obtengo el valor de la descripción
          let descripcion = ''
          let esNS = ''
          if(result.CodigoResultado === 0){
            esNS = result.Datos.esNS
            descripcion = result.Datos !== 'null' ? result.Datos.descripcion : this.$t('SOLICITUDES_descripcion_vacia')
            }
          else{
            descripcion = getMensajeInternacionalizado(result.CodigoResultado, result.DescripcionResultado)
            esNS = result.Datos.esNS
            }
          
          // actualizo la descripción dependiendo del campo
          this.nsDescription = descripcion
          this.esNs = esNS
          this.ocultar()
          // indico si es un número de serie válido
          this.validNs = result.CodigoResultado === 0

          // lanzo el evento onChange
          this.onChange({ name: this.name, value: this.nsValue, description: this.nsDescription, valid: this.validNs })
        })
      },
      ocultar(){
        this.$emit('ocultar', this.esNs)
      }
    },
    watch: {
      modelValue(newVal) {
        if(newVal !== this.nsValue)        {
          this.nsValue = newVal.toUpperCase()
          this.getDescripcion()
        }
      }
    }
  }

</script>

<style scoped >
  .container_card_guardado {
  display: flex;
  text-align: center !important;
}

  .label {
    text-align: left;
    margin-top: 15px;
    margin-bottom: 4px;
    font-size: 14px;
  }

  #nro_serie{
    text-transform: uppercase !important;
  }
  .qrCodeScanContainer {
    display: inline;
  }

  .qrCodeScanInput {
    width: calc(100% - 40px);
    float: left;
  }

  .qrCodeScanIcon {
    float: right;
    width: 31px;
    height: 31px;
    margin-left: 9px;
  }

  .qrCodeScanIcon > img {
    height: 31px;
  }

  .qrCodeReader.enabled {
    display: block;
    margin-top: 40px;
  }

  .qrCodeReader.disabled {
    display: none;
  }

  .descripcion {
    display: inline-block;
    width: 100%;
    text-align: left;
    font-size: 12px;
    margin-top: 10px;
    color: #666;
  }
  .descripcion.invalido {
    color: #F44336;
  }

</style>